module.exports = "<my-data-display my-data=\"$$commande.data.myCommandes\"\n  my-nature=\"'commande'\"\n  enable-local-search=\"true\"\n  enable-title=\"true\"\n  enable-badges=\"true\"\n  enable-buttons=\"true\"\n  enable-excel=\"true\"\n  enable-links=\"true\"\n  enable-back=\"true\">\n</my-data-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/commande/templates/home.html
// module id = 1553
// module chunks = 0